const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class CulturalInfluence extends Event {
    constructor(){
        super(
            Age.Age1,
            EventNames.CulturalInfluence,
            "Each civilization immediately scores culture equal to the amount of culture it produces.",
            {}
        )
    }
}

module.exports = CulturalInfluence;